import { render, staticRenderFns } from "./toOrderMeal.vue?vue&type=template&id=026c380e&scoped=true"
import script from "./toOrderMeal.vue?vue&type=script&lang=js"
export * from "./toOrderMeal.vue?vue&type=script&lang=js"
import style0 from "./toOrderMeal.vue?vue&type=style&index=0&id=026c380e&prod&lang=less&scoped=true"
import style1 from "./toOrderMeal.vue?vue&type=style&index=1&id=026c380e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026c380e",
  null
  
)

export default component.exports